export type ResourceName = "CPU" | "Disk" | "Memory" | "Core" | "Folder";
export const recordNameEnum: Record<number, ResourceName> = {
  0: "CPU",
  10: "Disk",
  20: "Memory",
  30: "Core",
  40: "Folder",
};
export const recordNameArray: ResourceName[] = ["Memory", "Disk", "CPU"];
